// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "/" + "449cd4534726259c2a8c" + ".js";
};